export const PASSWORD_ENDPOINT = {
  CHANGEPASSWORD: "v4/users/password",
};
